/** Размер файла */
export var formatFileSize = function (bytes) {
    if (bytes === 0)
        return "0 Б";
    var k = 1024;
    var sizes = ["Б", "КБ", "МБ", "ГБ"];
    var i = Math.floor(Math.log(bytes) / Math.log(k));
    return "".concat((bytes / Math.pow(k, i)).toFixed(2).replace(/\./, ","), " ").concat(sizes[i]);
};
/** Смена расширения файла */
export var changeExtension = function (filename, newExt) {
    // Убираем точку из нового расширения, если она есть
    newExt = newExt.replace(/^\./, "");
    // Находим последнюю точку в имени файла
    var lastDotIndex = filename.lastIndexOf(".");
    // Если точка не найдена или находится в начале имени
    if (lastDotIndex <= 0) {
        return "".concat(filename, ".").concat(newExt);
    }
    return "".concat(filename.substring(0, lastDotIndex), ".").concat(newExt);
};
